export default __webpack_public_path__ + "3e922a9043bf571f36438182c3a2bfe9.png";